"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessAuthorizationDataSchema = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
// https://docs.railz.ai/docs/railz-connect-event-listeners#authorization
exports.SuccessAuthorizationDataSchema = zod_1.z.object({
    businessName: zod_1.z.string(),
    businessUuid: zod_1.z.string(),
    connectionUuid: zod_1.z.string(),
    serviceName: common_1.RailzAccountingServiceNameSchema,
});
//# sourceMappingURL=RailzConnect.js.map